import React, { useState, useEffect } from "react";
import Serviceclasses from "../ServicePage/Service.module.css";
import { gethomeserviceCategory } from "../../../Services/APIrequests"; // Using the updated API request
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Image } from "antd";

const Servicess = ({ service }) => {
  const navigate = useNavigate();
  const { category, description, thumbnailUrl, id } = service;

  const handleClick = (id, category) => {
    const formattedCategory = category.replace(/\s+/g, "_");
    navigate(`/services/${formattedCategory}`);
  };

  return (
    <div
      className={Serviceclasses.Servicecard}
      onClick={() => handleClick(id, category)}
    >
      <div className={Serviceclasses.Servicecard2}>
        <div className={Serviceclasses.ServiceIconContainer}>
          <div
            className={Serviceclasses.ServiceIcon}
            onClick={(e) => e.stopPropagation()}
          >
            {thumbnailUrl ? (
              <Image
                src={thumbnailUrl}
                alt={category}
                width={48}
                height={48}
                preview={{
                  mask: <div style={{ fontSize: '12px' }}>Preview</div>,
                }}
                className={Serviceclasses.ServiceIconImage}
              />
            ) : (
              <div className={Serviceclasses.ServiceIconPlaceholder}>
                {category.charAt(0)}
              </div>
            )}
          </div>
        </div>

        <h2 className={Serviceclasses.ServicecardTitle}>{category}</h2>

        <p className={Serviceclasses.Servicecsmallarddescr}>
          {description || "Description not available"}
        </p>

        <div className={Serviceclasses.Servicecard_readmore}>
          <div
            onClick={() => handleClick(id, category)}
            className={Serviceclasses.ServicecardLink}
          >
            Read More <BsArrowRight />
          </div>
        </div>
      </div>
    </div>
  );
};

const Serviceclassess = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await gethomeserviceCategory(); // Fetch categories from the API
        if (response.data && Array.isArray(response.data.categories)) {
          const sortedServices = response.data.categories.sort(
            (a, b) => a.priority - b.priority
          );
          setServices(sortedServices); // Set sorted services
        } else {
          console.error("Unexpected response structure:", response);
          setServices([]);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchServices();
  }, []);

  return (
    <div className={Serviceclasses.Servicecontainer}>
      <h1>
        Our <span className={Serviceclasses.ServiceTitle}>Services</span>
      </h1>
      <p className={Serviceclasses.ServiceSubtitle}>
        Comprehensive compliance solutions tailored for your business
      </p>
      <div className={Serviceclasses.ServicecardGrid}>
        {services.length > 0 &&
          services.map((service) => (
            <Servicess key={service.id} service={service} />
          ))}
      </div>

      {/* Show message outside the grid if no services are available */}
      {services.length === 0 && (
        <p
          style={{ textAlign: "center", marginTop: "20px", fontWeight: "500" }}
        >
          No services available at the moment.
        </p>
      )}
    </div>
  );
};

export default Serviceclassess;
